import { defineSlotRecipe } from '@chakra-ui/react';
import { nativeSelectAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: nativeSelectAnatomy.keys(),
  variants: {
    size: {
      md: {
        field: {
          textStyle: 'md',
        },
      },
      lg: {
        field: {
          '--input-height': 'sizes.12',
        },
      },
    },
  },
});
